export default {
  methods: {
    getImage(image, thumb) {
      let source = null
      if (image.imageFd) {
        let filename = image.imageFd
        if (thumb) {
          filename = 'thumb_' + image.imageFd
        }
        source = process.env.VUE_APP_API_URL + '/uploads/images/' + filename
      }
      return source
    }
  }
}
